import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

// Create a new store instance.
export default createStore({
    state() {
        return {
            dark_mode: false,
            currency: 'USD',
            usdRate: '0.00025071312605834',
            currenciesValues: [],
            favorites: [],
        }
    },
    mutations: {
        changeCurrency(state, c) {
            state.currency = c
        },
        changeColorMode(state, c) {
            state.dark_mode = c
        },
        setCurrencies(state, c) {
            state.currenciesValues = c
        },
        setUsdRate(state, c) {
            state.usdRate = c
        },
        setFavorites(state, f) {
            state.favorites = f
        },
    },
    actions: {},
    getters: {
        getMyState: state => state
    },
    plugins: [createPersistedState()],
})